import React, { useState } from 'react'
import '../../../Style/online-train/Stylee.css'
const Show = ({ row, mat, ques,ans }) => {
  const [display, setdisplay] = useState(1)
  const anskey = []
  let temp = 0;
  mat.map((i) => {
    i.map((j) => {
      temp += j;
    })
    anskey.push(temp)
    temp = 0;
  })
  const reloadFun = (event)=>{
    window.location.reload()
  }
  return (
    <div className={display?"display":".hide-btn"}>
      {/* <div ref={targetRef}> */}
      <div className='X-btn' onClick={()=>{reloadFun()}}>X</div>
      <div className={ "mat-show"}>
        <div className='mat-row'>
          {mat.map((row, i) => (
            <div key={i} className=''>
              {row.map((cell, j) => (<div className='color'>{cell}</div>))}
              <div className='color'>--</div>
              <div className={ans?anskey[i]==ans[i]?"crt":"wrng":""}>{anskey[i]}</div>
              <div className={ans?anskey[i]==ans[i]?"crt":"wrng":""}>{ans?ans[i]:""}</div>
              <br/>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
export default Show 